const logout = () => ({
    submitForm(event) {
        event.preventDefault();
        this.$refs.form.submit();
    }
});

export default function exportLogout() {
    window.logout = logout;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/logout.js